export default "__VITE_ASSET__pC55tUVU__"